export const enumValidator = options => value => options.indexOf(value) !== -1;

export const typographyColorValidator = enumValidator([
  "inherit",
  "text",
  "medium",
  "disabled",
  "primary",
  "positive",
  "negative",
  "on-primary"
]);

export const colorValidator = enumValidator(["primary", "positive", "negative", "dark"]);
